export default __webpack_public_path__ + "static/media/background.35e729c2.jpg";